<template>
  <div>
    <LazyHydrate when-idle>
      <BaseTopCard :details="topCardDetails" isWhiteBg />
    </LazyHydrate>
    <section class="gridClass my-16">
      <h2 class="hidden"> {{ topCardDetails.title }} </h2>
      <div class="flex w-full">
        <div
          @click="clieckedTab(item.id)"
          v-for="item in titleTab"
          :key="item.id"
          class="flex-grow text-center pb-2 border-b-2 border-blue-700"
          :class="tabItem === item.id ? '  font-bold' : 'border-opacity-10 cursor-pointer'"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="mt-10  p-10  bg-blue-450 bg-opacity-5 rounded-xl">
        <template v-if="tabItem === 1">
          <div class="">
            <Form
              class="w-full"
              :validation-schema="schema1"
              :initial-values="initialValues1"
              @submit="handleSubmit"
            >
              <div
                class="flex items-center justify-between [&>*]:w-[48%] flex-wrap"
              >
                <BaseInput
                  name="companyName"
                  type="text"
                  class=""
                  placeholder="نام شرکت"
                />
                <BaseInput
                  name="activity"
                  type="text"
                  class=""
                  placeholder="حوزه کسب‌وکار "
                />
                <BaseInput
                  name="vcode"
                  type="text"
                  class=""
                  placeholder=" شناسه ملی"
                  isNumber
                />
                <BaseInput
                  name="number"
                  type="text"
                  class=""
                  placeholder=" شماره تلفن"
                  isNumber
                />
                <BaseInput
                  name="name"
                  type="text"
                  class=""
                  placeholder="نام و نام خانوادگی نماینده شرکت "
                />
                <BaseInput
                  name="num"
                  type="text"
                  class=""
                  placeholder=" شماره موبایل نماینده شرکت"
                  isNumber
                />
              </div>
              <BaseInputTextarea name="text" placeholder="توضیحات (اختیاری) " />
              <BaseButton size="full" type="submit" text="ارسال درخواست" />
            </Form>
          </div>
        </template>
        <template v-else-if="tabItem === 2">
          <div class="">
            <Form
              class="w-full"
              :validation-schema="schema2"
              :initial-values="initialValues2"
              @submit="handleSubmit"
            >
              <div
                class="flex items-center justify-between [&>*]:w-[48%] flex-wrap"
              >
                <BaseInput
                  name="name"
                  type="text"
                  placeholder="نام و نام خانوادگی "
                />
                <BaseInput name="vcode" type="text" placeholder="  کد ملی" isNumber />
                <BaseInput
                  name="number"
                  type="text"
                  placeholder="  شماره موبایل"
                  isNumber
                />
                <BaseInput
                  name="email"
                  type="text"
                  placeholder=" ایمیل (اختیاری) "
                />
              </div>
              <BaseInputTextarea name="text" placeholder="توضیحات (اختیاری) " />
              <BaseButton size="full" type="submit" text="ارسال درخواست" />
            </Form>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script setup>
import {object, string} from 'yup'
import { Form } from 'vee-validate';
const {validateFaChar ,validateMobile , validateEmail , validateNationalCode}  = useInputHelpers();

const { post, loading } = useSendMail()

const successModalButton = ref()
const tabItem = ref(1)

const clieckedTab = (id) => {
  tabItem.value = id
}

const topCardDetails = {
  title: "نمایندگی فروش محصولات نواتل",
  desc: "همین امروز به خانواده بزرگ نواتل بپیوندید. 20سال تجربه در حوزه ارائه خدمات مخابراتی و یکپارچه‌سازی ارتباطات، کمک کرده تا نواتل بیش از هشت سال در کنار کسب‌وکارهای ایرانی باشد. مرکــــــــــــــــــز تلفن ابری نواتل نیاز هر کسب‌و‌کاری است که می‌خواهد روایتی متفاوت و حرفه‌ای‌تری در زمینه یکپارچه‌سازی ارتباطات خود با مشتریان و کارمندانش داشته باشد.",
  img: "/img/agent.webp",
}

const titleTab = [
  { id: 1, title: "درخواست نمایندگی حقوقی" },
  { id: 2, title: "درخواست نمایندگی حقیقی" },
]

const initialValues1 = {
  companyName: '',
  activity: '',
  vcode: '',
  number: '',
  name: '',
  num: '',
  text: '',
  type: 'hoquqi'
}

const initialValues2 = {
  name: '',
  vcode: '',
  number: '',
  email: '',
  text: '',
  type: 'haqiqi'
}


const schema1 = object({
  companyName: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  activity: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  vcode: string().min(11, "شناسه ملی معتبر نیست").max(11, "شناسه ملی معتبر نیست")
    .required('این فیلد نباید خالی باشد.'),
  number: string().min(11, "مقدار وارد شده معتبر نیست").max(11, "مقدار وارد شده معتبر نیست")
    .required('این فیلد نباید خالی باشد.'),
  name: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  num: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  text: string()
})

const schema2 = object({
  name: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateFaChar),
  vcode: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateNationalCode),
  number: string()
    .required('این فیلد نباید خالی باشد.').test("", "مقدار وارد شده معتبر نیست.", validateMobile),
  email: string().test("", "مقدار وارد شده معتبر نیست.", validateEmail),
  text: string(),
})

const handleSubmit = async (form, { resetForm }) => {
  if(!loading.value){

    form.action = 'reseller'
    const { data, error } = await post({
    body: { model: form }
  })

  if (!error.value && data.value === 'ok') {
    resetForm()
    successModalButton.value.click()
  }
}
}
useHead({

   link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/SalesAgent/"
    }
  ]
})
</script>
